/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSkiTripTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSkiTrip,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Hit the Slopes!",
    "Ski Trip Awaits!",
    "Snowy Adventures!",
  ],
  title: "Ski Trip",
  description: "Organize a thrilling ski trip.",
  longDescription:
    "Gather your friends for an exciting ski trip! Choose a date, decide on the resort, and plan activities for the weekend!",
  emoji: "⛷",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Ski Trip",
          emoji: "⛷",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go on the ski trip?",
          emoji: "📅",
          completeAction: {
            question: "Decide on the ski resort?",
            description: "Which ski resort do we want to visit?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What ski resort should we choose?",
                emoji: "🏔",
                completeAction: {
                  question: "Decide on activities during the trip?",
                  description:
                    "What activities should we plan for the ski trip?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we include?",
                      emoji: "❄",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Hit the Slopes!",
    outroDescription: "Your ski trip plans are set! Enjoy the snow!",
  },
};
